import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class TimeZoneService {
  private timezoneStorageKey = 'timezone';
  private changedTimezoneStorageKey = 'newTimezone';
  updatedTimezone$: BehaviorSubject<string> = new BehaviorSubject('UTC');
  updatedNewTimezone$: BehaviorSubject<string> = new BehaviorSubject('UTC');

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    const userTimeZone = this.getUserTimeZone() || 'UTC';
    this.updatedTimezone$.next(userTimeZone);
    this.updatedNewTimezone$.next(userTimeZone);
  }

  setTimeZone(timeZoneName: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.timezoneStorageKey, timeZoneName);
      this.updatedTimezone$.next(this.getUserTimeZone());
    }
  }

  setNewTimeZone(timeZoneName: string) {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem(this.changedTimezoneStorageKey, timeZoneName);
      this.updatedNewTimezone$.next(this.getUserTimeZone());
    }
  }

  getUserTimeZone(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(this.timezoneStorageKey);
    }
    return null;
  }

  getUserNewTimeZone(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return sessionStorage.getItem(this.changedTimezoneStorageKey);
    }
    return null;
  }

  convertTimeZone(time: Date, timezone?: string): string | Date {
    const format = 'YYYY/MM/DD HH:mm:ss';
    let zone: string;
    if(!timezone){
      zone = this.getUserNewTimeZone() || this.getUserTimeZone();
    }
    else{
      zone = timezone;
    }
    return zone ? moment(time, format).tz(zone).format(format) : time;
  }

  convertTimeZoneDate(time: Date, timezone?: string): Date {
    const format = 'YYYY/MM/DD HH:mm:ss';
     let zone: string;
    if(!timezone){
      zone = this.getUserNewTimeZone() || this.getUserTimeZone();
    }
    else{
      zone = timezone;
    }
    return zone ? new Date(moment(time, format).tz(zone).format(format)) : time;
  }

  getDisplayTimeZone(): string {
    const zone = this.getUserNewTimeZone() || this.getUserTimeZone() || moment.tz.guess();
    return 'GMT ' + moment().tz(zone).format('Z');
  }

  timeToDate(time: string, timezone: string): Date {
    return moment(time, 'HH:mm:ss').tz(timezone).toDate();
  }
}
